import { BaseSvgIcon } from './BaseSvgIcon'

export const UserIcon = (props: any) => {
  const { width = 19, height = 19, fill = 'currentColor', ...rest } = props

  return (
    <BaseSvgIcon width={width} height={height} viewBox="0 0 100 100" fill="none" {...rest}>
      <path
        d="M50 0C35.4611 0 23.6328 11.8283 23.6328 26.3672C23.6328 40.9061 35.4611 52.7344 50 52.7344C64.5389 52.7344 76.3672 40.9061 76.3672 26.3672C76.3672 11.8283 64.5389 0 50 0Z"
        fill={fill}
      />
      <path
        d="M82.8059 69.96C75.5871 62.6303 66.0174 58.5938 55.8594 58.5938H44.1406C33.9828 58.5938 24.4129 62.6303 17.1941 69.96C10.0107 77.2537 6.05469 86.8814 6.05469 97.0703C6.05469 98.6883 7.36641 100 8.98438 100H91.0156C92.6336 100 93.9453 98.6883 93.9453 97.0703C93.9453 86.8814 89.9893 77.2537 82.8059 69.96Z"
        fill={fill}
      />
    </BaseSvgIcon>
  )
}
